/**
 * Administration du catalogue d'auto-formations (réservé aux admins).
 * Les routes de consultation du portail formateur vivent dans portails.js.
 */
const BASE = '/api/auto-formations-admin'

export const autoFormationsAdminEndpoints = {
  arbre: () => `${BASE}/arbre`,



  // Les modules s'adressent par thème : le niveau « compétence » du schéma
  // n'est exposé nulle part, ni ici ni côté serveur.
  // Les thèmes ont disparu : un parcours se rattache à une catégorie du
  // catalogue, qui se crée depuis l'écran « Catégories de formations ».
  modulesDeLaCategorie: (categorieId) => `${BASE}/categories/${categorieId}/modules`,
  module: (id) => `${BASE}/modules/${id}`,

  // Un module porte une liste ordonnée de contenus (textes et vidéos mêlés).
  contenus: (moduleId) => `${BASE}/modules/${moduleId}/contenus`,
  contenu: (id) => `${BASE}/contenus/${id}`,

  // Le QCM ne s'adresse que pour être publié ou dépublié : il est créé à la
  // demande par le serveur à la première question.
  quiz: (id) => `${BASE}/quiz/${id}`,

  // Le QCM d'un module est unique : les questions s'adressent par module.
  questions: (moduleId) => `${BASE}/modules/${moduleId}/questions`,
  question: (id) => `${BASE}/questions/${id}`,

  reordonner: () => `${BASE}/reordonner`,
}
